import { makeStyles } from '@material-ui/core/styles'

export const firebaseMarkerStyles = makeStyles(() => ({
  firebaseMarkerIcon: {
    '&:hover': {
      cursor: 'pointer',
    },
  },
}))

export default firebaseMarkerStyles
